export class FlipGraphSubScores {
  name: string
  numberOfItems: number
  percentScore: number
  percentScoreRounded: number

  constructor(data?: any) {
    this.name = data?.name ?? ''
    this.numberOfItems = data?.numberOfItems ?? 0
    this.percentScore = data?.percentScore ?? 0
    this.percentScoreRounded = data?.percentScoreRounded ?? 0
  }
}
